import { render, staticRenderFns } from "./army.vue?vue&type=template&id=621492a3"
import script from "./army.vue?vue&type=script&lang=js"
export * from "./army.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports